// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"CopilotAccessRequestSuccessBanner-module__bannerWrapper__oLuTXPG"};